<template>
    <div>
        <div>
            <Notification v-if="! fixfloUrl">
                Loading...
            </Notification>

            <iframe
                v-if="fixfloUrl"
                scrollbars="no"
                style="border:0px; width:100%; height:700px; overflow:hidden;"
                :src="fixfloUrl"
            >
                Loading...
            </iframe>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Notification from './Notification.vue';

export default {
    components: {
        Notification,
    },

    computed: {
        ...mapState('tenancyProperty', [
            'property',
            'fixfloUrl',
        ]),
    },

    mounted() {
        this.getFixfloUrl();
    },

    methods: {
        getFixfloUrl() {
            this.$store.dispatch('tenancyProperty/getFixfloUrl', this.property.TenancyFK);
        },
    },
};
</script>
